import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const playIcon: SvgIconData = {
  viewBox: '20 15.7 60.39 69.07',
  element: (
    <path d="M78.63 47.2 24.87 16.17a3.2 3.2 0 0 0-3.3 0c-1.1.62-1.57 1.78-1.57 3.03v62.07c0 1.25.48 2.4 1.56 3.03.54.31 1.05.47 1.66.47q.9 0 1.7-.47l53.73-31.03a3.49 3.49 0 0 0-.02-6.07" />
  ),
};
